var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "t2-header-nav", attrs: { fluid: "" } },
    [
      _c(
        "v-container",
        { staticClass: "t2-header-nav__bar" },
        [
          _c(
            "v-row",
            { attrs: { align: "center", "no-gutters": "" } },
            [
              _c(
                "v-col",
                { staticClass: "t2-header-nav__logo", attrs: { cols: "auto" } },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "t2-logo",
                      attrs: {
                        to: _vm.currentUserShopSlug
                          ? "/" + _vm.currentUserShopSlug
                          : { name: "Home" },
                      },
                    },
                    [
                      _vm.currentCategoryImage
                        ? [
                            _c("img", {
                              staticClass: "t2-logo__img",
                              attrs: {
                                src: _vm.currentCategoryImage,
                                alt: _vm.currentCategoryName || _vm.appName,
                              },
                            }),
                          ]
                        : _vm.shopLogo
                        ? [
                            _c("img", {
                              staticClass: "t2-logo__img",
                              attrs: { src: _vm.shopLogo, alt: _vm.appName },
                            }),
                          ]
                        : [
                            _c("img", {
                              staticClass: "t2-logo__bi",
                              attrs: {
                                src: "/assets/img/header/header-bi.svg",
                                alt: _vm.appName,
                              },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "t2-logo__default",
                              attrs: {
                                src: "/assets/img/header/header-logo.svg",
                                alt: _vm.appName,
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "t2-header-nav__right",
                  attrs: { cols: "auto" },
                },
                [
                  _vm.isAuthenticated
                    ? [
                        _vm.isUseAfterLogin
                          ? _c(
                              "div",
                              { staticClass: "t2-icon-btn" },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: {
                                      attach: "",
                                      bottom: "",
                                      transition: "slide-y-transition",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "router-link",
                                                {
                                                  staticClass: "t2-icon-inner",
                                                  attrs: { to: "/after-login" },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "las la-home fs-22",
                                                        },
                                                        "i",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3867220008
                                    ),
                                  },
                                  [_vm._v(" "), _c("span", [_vm._v("홈")])]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.$optional("data.logobar_menu?.labels"),
                          function (menuLabel, i) {
                            return _c(
                              "div",
                              { key: i, staticClass: "t2-icon-btn" },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: {
                                      attach: "",
                                      bottom: "",
                                      transition: "slide-y-transition",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "router-link",
                                                {
                                                  staticClass: "t2-icon-inner",
                                                  attrs: {
                                                    to: _vm.$optional(
                                                      "data.logobar_menu.links"
                                                    )[i],
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "las fs-22 position-relative",
                                                          class: _vm.$optional(
                                                            "data.logobar_menu.icons"
                                                          )[i],
                                                        },
                                                        "i",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm.getCartCount > 0 &&
                                                      _vm.$optional(
                                                        "data.logobar_menu.links"
                                                      )[i] === "/cart"
                                                        ? _c("v-badge", {
                                                            staticClass:
                                                              "t2-header-badge",
                                                            attrs: {
                                                              color: "error",
                                                              content:
                                                                _vm.getCartCount,
                                                              inline: "",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(menuLabel))]),
                                  ]
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "t2-user-info" }, [
                          _c("span", { staticClass: "t2-user-info__name" }, [
                            _vm._v(_vm._s(_vm.currentUser.name)),
                          ]),
                          _vm._v(" "),
                          _vm.kumonBranch
                            ? _c(
                                "span",
                                { staticClass: "t2-user-info__branch" },
                                [_vm._v("(" + _vm._s(_vm.kumonBranch) + ")")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentUserCompany.company_name
                            ? _c(
                                "span",
                                { staticClass: "t2-user-info__company" },
                                [
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        _vm.currentUserCompany.company_name
                                      ) +
                                      ")"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-tooltip",
                          {
                            attrs: {
                              attach: "",
                              bottom: "",
                              transition: "slide-y-transition",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "t2-icon-btn",
                                          attrs: { to: { name: "Logout" } },
                                        },
                                        [
                                          _c(
                                            "i",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "las la-sign-out-alt fs-22",
                                                },
                                                "i",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2658076849
                            ),
                          },
                          [_vm._v(" "), _c("span", [_vm._v("로그아웃")])]
                        ),
                      ]
                    : [
                        _c(
                          "v-tooltip",
                          {
                            attrs: {
                              attach: "",
                              bottom: "",
                              transition: "slide-y-transition",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "t2-icon-btn",
                                        attrs: { to: _vm.loginLink },
                                      },
                                      [
                                        _c(
                                          "i",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "las la-sign-in-alt fs-22",
                                              },
                                              "i",
                                              attrs,
                                              false
                                            ),
                                            on
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          },
                          [_vm._v(" "), _c("span", [_vm._v("로그인")])]
                        ),
                      ],
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }